export const JackpotPotSVG = (props) => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.1178 12.0478C14.6975 13.0426 14.2941 11.0534 11.8738 11.0534C9.45355 11.0534 9.05017 12.5453 6.62989 12.0478C3.86767 11.4799 3.78239 7.08691 3.78239 7.08691C2.38422 10.656 2.88875 14.9148 5.05653 17.8417C6.54666 19.8537 8.65465 21 10.8646 21H12.5545C14.7645 21 16.8724 19.8537 18.3626 17.8417C19.6938 16.0444 21.1454 12.7402 19.9414 8.56692C19.9414 8.56692 18.6484 11.4186 17.1178 12.0478Z"
      fill="#dcdfe1"
    />
    <path
      d="M17.272 2.52393L18.9976 7.02979C20.3197 10.4813 19.8329 14.595 17.8071 17.3921C16.4215 19.3052 14.5013 20.3452 12.5386 20.3452H10.8521C8.88938 20.3452 6.96913 19.3051 5.5835 17.3921C3.55778 14.595 3.07002 10.4813 4.39209 7.02979L6.11865 2.52393H17.272Z"
      stroke="#dcdfe1"
      strokeWidth="1.30937"
    />
    <path
      d="M18.8604 1.52637V2.62988H4.53027V1.52637H18.8604Z"
      stroke={props.stroke || 'white'}
      strokeWidth="1.30937"
    />
  </svg>
)
